// Force button border + Playfair Display font
document.addEventListener('DOMContentLoaded', function() {
  // Button borders
  function applyButtonBorder() {
    document.querySelectorAll('.button:not(.visually-hidden):not(.slider-button):not(.slideshow__pause)').forEach(function(btn) {
      btn.style.setProperty('border', '1px solid #121212', 'important');
    });
  }
  applyButtonBorder();

  // Apply Playfair Display to headings
  function applyPlayfair() {
    document.querySelectorAll('h1, h2, h3, h4, .h0, .h1, .h2, .hxl, .hxxl, .banner__heading, .rich-text__heading, .title').forEach(function(el) {
      el.style.setProperty('font-family', "'Playfair Display', Georgia, serif", 'important');
    });
// Cormorant Infant for em inside headings
    document.querySelectorAll('h1 em, h2 em, h3 em, .banner__heading em, .rich-text__heading em, .title em').forEach(function(el) {
el.style.setProperty('font-family', "'Cormorant Infant', serif", 'important');
      el.style.setProperty('font-style', 'normal', 'important');
    });
  }
  applyPlayfair();

  // Watch for dynamic changes (cart, modals)
  var observer = new MutationObserver(function() {
    applyButtonBorder();
    applyPlayfair();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
